module.exports = __webpack_public_path__ + "man_with_tablet.dc6dcb45542f73a34fb4.png";


//////////////////
// WEBPACK FOOTER
// /Users/bright.ofosu/Documents/brytelabs/seedit-parent/seedit-website/src/assets/images/man_with_tablet.png
// module id = ../../../../../src/assets/images/man_with_tablet.png
// module chunks = styles